<template>
    <div class="wrapper">
        <CCHeader></CCHeader>
        <div class="data-wrapper">
            <CCSideBar></CCSideBar>
            <div class="main">   
                <div class="report">
                    <div class="report-filters">
                        <Filters :namespace="namespace" @apply="onApplyFilters"/>
                    </div>
                    <div class="flext-wrap">
                        <div class="table-main">
                            <div class="table-header" style="z-index:100">
                                <h4 class="table-header-title">AdGroup Report</h4>
                                <div class="control-wrapper">
                                    <div class="search-wrapper">
                                        <input type="text" name="search" v-model="searchPhrase" v-on:keyup.enter="useSearch()" placeholder="Search">
                                        <div @click="useSearch()">
                                            <i class="search-icon"></i>
                                        </div>
                                    </div>
                                    <div class="columns-customization-wrapper" style="z-index:1">
                                        <CustomizationColumns 
                                            :columns="columns"
                                            :selectedColumns="selectedColumns"
                                            :defaultSelectedColumns="defaultSelectedColumns"
                                            :fixedColumns="fixedColumns"
                                            :namespace="namespace"
                                            @apply="saveCustomizationColumns"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="tables-list">
                                <div class="report-table-wrapper">
                                    <Table
                                        :header="tableHeader"
                                        :body="tableBody"
                                    /> 

                                    <AdGroupDropdownMenu 
                                        :open="adGroupMenuShown" 
                                        :options="adGroupMenuOptions" 
                                        @close="closeAdGroupMenu()"
                                        @charts="showCharts"
                                    />                               

                                    <template v-if="reportStatus !== 'loading' && bodyRows.length === 0">    
                                        <div class="no-results">There are no results</div>
                                    </template>
                                </div>
                                <div class="table-wrapper-bottom">
                                    <div class="action-button-wrapper">
                                        <!--<button @click="exportReportAsCSV()">Export as CSV</button>-->
                                    </div>
                                    <div class="pagination-wrapper" v-if="report.totalCount">
                                        <CCTablePagination 
                                            :numberRows="tableBody.rows.length" 
                                            :paginationOptions="paginationOptions"
                                            :limit="limit"
                                            :totalCount="report.totalCount"
                                            :hasNextPage="pageInfo.hasNextPage"
                                            :hasPreviousPage="pageInfo.hasPreviousPage"
                                            @changePagination="onChangePagination"
                                            @previousPage="onPreviousPage"
                                            @nextPage="onNextPage"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-bind:class="'right-sidebar ' + (rightSidebarOpened ? '' : 'closed') ">
                            <RightSideBar 
                                :opened="rightSidebarOpened"
                                :dailyReportFilters="dailyReportFilters"
                                @close="closeRightSidebar()"
                                @open="openRightSidebar()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import '@/style/reports/base_report_style.scss';

    import moment from "moment";

    import adgroupReportModule from '@/store/modules/adgroupReport2/index';

    import CCHeader from '@/components/common/CCHeader';
    import CCSideBar from '@/components/common/CCSideBar';
    import Filters from '@/components/reports/adgroupReport2/Filters';
    import Table from '@/components/common/table_v3/Table';
    import { LineScalePulseOutRapidLoader as Spinner } from 'vue-loaders';
    import Builder from '@/components/common/table_v3/Builder';
    import CustomizationColumns from '@/components/common/customizationColumns/v1/CustomizationColumns';
    import CCTablePagination from '@/components/common/table_v3/TablePagination.vue';
    import AdGroupDropdownMenu from '@/components/reports/adgroupReport2/AdGroupDropdownMenu.vue';
    import RightSideBar from '@/components/reports/adgroupReport2/RightSideBar.vue';

    import storeMixin from '@/components/mixins/storeMixin';
    import fixableTableColumnMixin from '@/components/common/table_v3/mixin/fixable.mixin';
    import sortableTableColumnMixin from '@/components/common/table_v3/mixin/sortable.mixin';
    import comparableTableColumnMixin from '@/components/common/table_v3/mixin/comparable.mixin';

    import columns from '@/configs/adgroup-report2-config.js';
    import {formatNumbers, roundValue} from '@/helpers/format';

    export default {
        name: "adgroup-report",
        
        components: {
            CCHeader,
            CCSideBar,  
            Filters,
            Table,
            Spinner,
            CustomizationColumns,
            CCTablePagination,
            AdGroupDropdownMenu,     
            RightSideBar
        },

        mixins: [
            storeMixin,
            fixableTableColumnMixin,
            sortableTableColumnMixin,
            comparableTableColumnMixin
        ],

        beforeCreate(){
            if (!('adgroupReport2/' in this.$store._modulesNamespaceMap)) {
                this.$store.registerModule('adgroupReport2', {
                    namespaced: true,
                    modules: {
                        adgroupReportModule
                    }
                });
            }            
        },

        created() {            
            this.loadFiltersFromUrl().then(() => {
                if( this.getUrlQueryParam('load', false, true) === true ) {
                    this.loadReport();
                }
            });            
        },
 
        data(){
            return {
                additionRows: { 1: { 'revenue' : [10]}},
                dailyReportFilters: {},
                rightSidebarOpened: false,
                adGroupMenuShown:false,
                adGroupMenuOptions: {},
                namespace: 'adgroupReport2',   
                columns: columns,
                colunmColspan: {},                
                reportStatus: 'init',
                paginationOptions: [
                    {
                        label: '10',
                        value: 10
                    },
                    {
                        label: '25',
                        value: 25
                    },
                    {
                        label: '50',
                        value: 50
                    },
                    {
                        label: '100',
                        value: 100
                    },
                    {
                        label: '200',
                        value: 200
                    }
                ],
                defaultSelectedColumns: [
                    'siteName',
                    'sourceName',
                    'campaignName',
                    'adGroupName',
                    'boughtClicks',
                    'cost',
                    'cpc',
                    'cpa',
                    'soldClicks',
                    'revenue',
                    'opCtr',
                    'profit'
                ],

                defaultSortedColumns: [{ "boughtClicks" : "desc" }]              
            }
        },


        computed: {

            numberSelectedSites: function(){
                return _.get(this.nsStoreGetter('appliedFilters'), 'siteIdIn', []).length;
            },

            searchPhrase: {
                get() {
                    return this.nsStoreGetter('selectedFilters')['searchPhrase'];
                },
                set(value) {
                    this.nsStoreDispatch('setSelectedFilter', { searchPhrase: value})
                }
            },

            dateRanges: function() {
                return this.nsStoreGetter('selectedFilters')['dateRangesIn'];
            },

            dateComparison: function() {
                return this.reportStatus === 'loaded_comparable';
            },

            pageInfo: function() {
                return this.nsStoreGetter('pageInfo');
            }, 
            
            report: function() {
                return this.nsStoreGetter('report');
            },

            limit: function() {
                return this.nsStoreGetter('limit');
            },

            cursor: function() {
                return this.nsStoreGetter('cursor');
            },

            selectedColumns: function() {
                return this.nsStoreGetter('selectedColumns');
            },

            fixedColumns: function() {
                return this.nsStoreGetter('fixedColumns');
            },

            sortedColumns: function() {
                return this.nsStoreGetter('sortedColumns');
            },

            tableColumns: function() {
                let columns = [];
                let self  = this;
                let colunmColspan = this.colunmColspan;
                this.columns.map(column => {
                    let columnClone = _.cloneDeep(column);
                    _.set(columnClone, 'meta.attributes.colspan', 1);
                    columns.push(columnClone);
                });

                this.registerSortClickCallback(columns, (sortedColumns, finalSort) => {
                    this.nsStoreDispatch('setSortedColumns', sortedColumns).then(() => {
                        if( finalSort ) {
                            this.loadReport();
                        }
                    })
                }, this.defaultSortedColumns);

                this.registerFixClickCallback(columns, (column) => {                    
                    let fixedColumns = _.cloneDeep(this.fixedColumns);
                    let index = fixedColumns.indexOf(column.id);
                    if( index === -1 ) {
                        fixedColumns.push(column.id);
                    } else {
                        fixedColumns.splice(index, 1);
                    }
                    this.nsStoreDispatch('setFixedColumns', fixedColumns).then(() => {
                        this.updateUrl();
                    });                    
                });

                this.registerCompareClickCallback(columns, (column) => {
                    let cols = _.get(column, 'meta.attributes.colspan', 1);
                    this.$set(column.meta.attributes, 'colspan', cols == 1 ? 2 : 1);
                });

                return columns;
            },

            tableHeader: function() {
                let cells = {};
                let empty = true;
                let builder = new Builder;
                let tableColumns = _.cloneDeep(this.tableColumns);    
                tableColumns = _.filter(tableColumns, column => {
                    let index = this.selectedColumns.findIndex( selectedColumnId => {
                        return selectedColumnId == column.id;
                    });
                    return index !== -1 && (column.id !== 'siteName' || this.numberSelectedSites !== 1);                    
                });            

                _.map(tableColumns, column => {

                    let columnId = column.id;
                    let index = this.columns.findIndex(column => column.id == columnId);
                    
                    if( index !== -1 ) {
                        column.comparable = this.dateComparison && this.columns[index].comparable;
                    }

                    let cols = _.get(column, 'meta.attributes.colspan', 1);
                    cells[column.id] = [];
                    if( cols > 1  ) {
                        empty = false;
                        _.map(this.dateRanges, (dateRange, dateRangeIndex) => {
                            let cell = builder.cell({
                                value: dateRange,
                                meta: {
                                    component: 'TableHeaderDateRange',
                                }
                            });
                            cells[column.id].push(cell)
                        })                        
                    } else {
                        cells[column.id].push('')
                    }
                }); 

                let rows = [];
                rows.push(builder.row(cells));

                return {
                    columns: tableColumns,
                    fixedColumns: this.fixedColumns,
                    sortedColumns: this.sortedColumns,
                    rows: this.dateComparison && !empty ? rows : []
                }
            },

            tableBody: function(){
                let body = {
                    rows: this.bodyRows
                }

                let builder = new Builder;  
                return builder.body(body);
            },      

            bodyRows: function() {
                let self    = this;
                let builder = new Builder;
                let columns = this.tableColumns;
                let additionRows = this.additionRows;
                let rows = [];
                if( this.reportStatus === 'loading' ) {
                    let row = builder.row({
                        cells: {},
                        meta: {
                            component: 'RowLoading'
                        }
                    });
                    rows.push(row);

                } else if ( _.isObject(this.report.edges) ) {
                    this.report.edges.map( (edge, rowIndex) => {
                        let cells = {};
                        _.map(this.dateRanges, (dateRange, dateRangeIndex) => {
                            //if( dateRangeIndex !== 0 ) return;

                            let node  = {};
                            let nodeIndex = edge.node.findIndex(value => value.dateRangeIndex === dateRangeIndex);
                            if( nodeIndex !== -1) node = edge.node[nodeIndex]; 

                            _.map(columns, column => {
                                let cols = _.get(column, 'meta.attributes.colspan', 1);
                                if( cols > dateRangeIndex ) {
                                    cells[column.id] = cells[column.id] || [];
                                    let value = _.get(node, column.id, undefined);  
                                    value = this.formatColumnData(column.id, value);

                                    let component = undefined;
                                    let events    = {};
                                    switch(column.id) {
                                        case 'adGroupName':
                                            component = 'AdGroupReportAdgroup';
                                            events.onClick = function(event) {
                                                event.stopPropagation();
                                                self.showAdGroupMenu({
                                                    top: event.clientY,
                                                    left: event.clientX,
                                                    node: node
                                                });
                                            } 
                                            break;

                                        case 'revenue':                                            
                                            component = 'AdGroupReportRevenue';
                                            events.onClick = function(event) {
                                                event.stopPropagation();
                                                
                                                setTimeout(() =>{

                                                    if( _.has(self.additionRows, rowIndex) ) {
                                                        self.$delete(self.additionRows, rowIndex);
                                                    } else {
                                                        self.$set(self.additionRows, rowIndex, { 
                                                            cells: {
                                                                'revenue' : { 
                                                                    value: [Math.random()],
                                                                    meta: {
                                                                        attributes: {
                                                                            colspan: 10
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            id: Math.random()
                                                        });   
                                                    }
                                                }, 10);

                                                //self.additionRows.splice(rowIndex+1, 0, { 'revenue' : [10]});
                                                //self.$set(self.additionRows, rowIndex, { 'revenue' : [Math.random()] });
                                                //console.log(self.additionRows);
                                            } 
                                            break;
                                    }

                                    let cell = builder.cell({
                                        value: value,
                                        meta: {
                                            component: component,
                                            events: events
                                        }
                                    });

                                    cells[column.id].push(cell);
                                }
                            });
                        });
                        rows.push({
                            cells: cells,
                            id: rowIndex
                        });

                        if( _.has(additionRows, rowIndex) ) {
                            rows.push(additionRows[rowIndex]);
                        }
                    });
                }

                return rows;
            }
        },

        methods: {

            formatColumnData(columnId, value) {
                if( value === undefined ) return 'N/A';
                if( value === null )      return 'N/A';

                switch(columnId) {
                    case 'boughtClicks':
                    case 'soldClicks':
                    case 'impressions':
                    case 'conversions':
                        return formatNumbers(value);

                    case 'cost':
                    case 'cpc':
                    case 'cpa':
                    case 'revenue':
                    case 'profit':
                    case 'rpc':
                    case 'rps':
                    case 'margin':
                        return formatNumbers(roundValue(value, 4));

                    case 'scrubRate':
                    case 'avgPos':
                        return roundValue(value, 1);

                    case 'adCtr':
                    case 'opCtr':
                        return roundValue(value, 0);

                    case 'maxCpc':
                    case 'maxCpa':
                        return value > 0 ? roundValue(value, 1) : value;
                }
                return value;

            },

            showCharts: function(node = null) {            
                
                let customFilters = {};
                if( _.isObject(node) ) {
                    customFilters = {
                        siteIdIn : [node.siteId],
                        sourceIdIn : [node.sourceId],
                        campaignName : node.campaignName,
                        adGroupName : node.adGroupName,
                    }
                }

                let filters = _.cloneDeep(this.nsStoreGetter('appliedFilters'));
                this.dailyReportFilters = _.merge(filters, customFilters);

                this.openRightSidebar();
            },

            openRightSidebar: function() {
                this.rightSidebarOpened = true;
            },

            closeRightSidebar: function() {
                this.rightSidebarOpened = false;
            },

            showAdGroupMenu: function(options) {
                this.adGroupMenuOptions = options;
                this.adGroupMenuShown = true;
            },

            closeAdGroupMenu: function() {
                this.adGroupMenuShown = false;
            },

            setUrlQueryParam(paramName, paramValue, encode = false) {
                let query = _.cloneDeep(this.$route.query) || {};
                if( _.isFunction(encode) ) {
                    paramValue = encode(paramValue);               
                }
                else {
                    paramValue = encode ? JSON.stringify(paramValue) : paramValue;
                }
                query[paramName] = paramValue;  
                this.$router.push({path: this.$route.path, query: query});
            },

            getUrlQueryParam(paramName, defaultValue = undefined, dencode = false) {
                let query = _.cloneDeep(this.$route.query) || {};
                let paramValue = defaultValue;
                if( query[paramName] !== undefined ) {
                    paramValue = query[paramName];
                    
                    if( _.isFunction(dencode) ) {
                        paramValue = dencode(paramValue);               
                    }
                    else {
                        paramValue = dencode ? JSON.parse(paramValue) : paramValue;
                    }
                }
                return paramValue;
            },

            removeUrlQueryParam(paramName,) {
                let query = _.cloneDeep(this.$route.query) || {};
                _.unset(query, paramName);
                this.$router.replace({path: this.$route.path, query: query});
            },

            async onChangePagination(limit) {
                await this.nsStoreDispatch('setLimit', limit);
                await this.nsStoreDispatch('setCursor', null);
                await this.nsStoreDispatch('setDirection', null)
                
                this.removeUrlQueryParam('cursor');
                this.loadReport();                                
            },

            onNextPage() {
                this.nsStoreDispatch('setDirection', 'after')
                    .then(() => {
                        this.setUrlQueryParam('cursor', this.pageInfo.endCursor);
                        return this.nsStoreDispatch('setCursor', this.pageInfo.endCursor);
                    })
                    .then(() => {
                        this.loadReport();
                    }); 
            },

            onPreviousPage() {
                this.nsStoreDispatch('setDirection', 'before')
                    .then(() => {
                        return this.nsStoreDispatch('setCursor', this.pageInfo.startCursor);
                    })
                    .then(() => {
                        this.loadReport();
                    });
            },

            saveCustomizationColumns(columns) {      
                this.$ls.set(this.namespace + '_lastColumns', columns);
                this.nsStoreDispatch('setFixedColumns', columns.fixedColumns).then(() => {
                    let loadReport = _.difference(columns.selectedColumns, this.selectedColumns).length !== 0;
                    return this.nsStoreDispatch('setSelectedColumns', columns.selectedColumns).then(() => {
                        return loadReport;
                    })
                }).then((loadReport) => {
                    if(loadReport) this.loadReport();
                });
            },

            useSearch() {                
                this.onApplyFilters();
            },

            onApplyFilters() {
                let self = this;
                return self.nsStoreDispatch('setReport', {}).then(() => {
                    return self.loadReport();
                });
            },

            loadReport() {
                let dateComparison = false;
                return new Promise(function (resolve) {
                    return resolve({});
                }).then(() => {
                    let tqIndex = this.selectedColumns.indexOf('tq') + 1;
                    let deviceIndex = this.selectedColumns.indexOf('deviceName') + 1;
                    let appliedFilters = this.nsStoreGetter('appliedFilters');
                    let deviceFilterLength = appliedFilters.deviceIdIn ? appliedFilters.deviceIdIn.length : 0; 

                    if( _.isArray(appliedFilters['dateRangesIn']) && appliedFilters['dateRangesIn'].length > 1 ) {
                        dateComparison = true;
                    }

                    //We can calculate TQ only on devece level (all devices or certain device)
                    //If selected 2 or more devices in filters we should add column "Device"
                    if( tqIndex && !deviceIndex && deviceFilterLength > 1 ) {
                        let selectedColumns = _.cloneDeep(this.selectedColumns);                    
                        selectedColumns.splice(tqIndex, 0, 'deviceName');
                        return this.nsStoreDispatch('setSelectedColumns', selectedColumns);
                    } 
                    

                }).then(() => {
                    this.updateUrl();
                }).then(() => {
                    return this.nsStoreDispatch('setReport', {});
                }).then(() => {
                    this.reportStatus = 'loading';
                    this.setUrlQueryParam('load', true, true);
                    return this.nsStoreDispatch('loadReport');
                }).finally(() => {
                    if( dateComparison ) {
                        this.reportStatus = 'loaded_comparable';
                    } else {
                        this.reportStatus = 'loaded';
                    }
                })
            },

            updateUrl() {                
                let appliedFilters = this.nsStoreGetter('appliedFilters')
                let filters = this.nsStoreGetter('selectedFilters');
                _.map(filters, (value, filterName) => {
                    let encode = this.encodedFilter(filterName);
                    let empty = appliedFilters[filterName] === undefined;   
                    if( ! empty ) this.setUrlQueryParam(filterName, appliedFilters[filterName], encode); else this.removeUrlQueryParam(filterName); 
                })

                if( this.limit )                      this.setUrlQueryParam('limit', this.limit);                       else this.removeUrlQueryParam('limit'); 
                if( this.cursor )                     this.setUrlQueryParam('cursor', this.cursor);                     else this.removeUrlQueryParam('cursor'); 
                if( this.selectedColumns.length > 0 ) this.setUrlQueryParam('columns', this.selectedColumns, true);     else this.removeUrlQueryParam('columns');            
                if( this.fixedColumns.length > 0 )    this.setUrlQueryParam('fixedColumns', this.fixedColumns, true);   else this.removeUrlQueryParam('fixedColumns'); 
                if( !_.isEmpty(this.sortedColumns) )  this.setUrlQueryParam('sortedColumns', this.sortedColumns, true); else this.removeUrlQueryParam('sortedColumns');                 
            },

            encodedFilter(filterName) {
                let inRexexp = new RegExp('In(Range)?$');
                let result = inRexexp.test(filterName);
                return result;
            },

            async loadFiltersFromUrl() {
                let selectedColumns = this.getUrlQueryParam('columns', [], true);
                let fixedColumns    = this.getUrlQueryParam('fixedColumns', [], true);
                if( selectedColumns.length === 0 ) {
                    let lastColumns = this.$ls.get(this.namespace + '_lastColumns');
                    if( lastColumns ) {
                        selectedColumns = lastColumns.selectedColumns;
                        fixedColumns    = lastColumns.fixedColumns;
                    }
                }

                if( selectedColumns.length === 0 ) {
                    selectedColumns = this.defaultSelectedColumns;
                }

                await this.nsStoreDispatch('setSelectedColumns', selectedColumns);
                await this.nsStoreDispatch('setFixedColumns', fixedColumns);
                await this.nsStoreDispatch('setSortedColumns', this.getUrlQueryParam('sortedColumns', this.defaultSortedColumns, true));                
                await this.nsStoreDispatch('setCursor', this.getUrlQueryParam('cursor', null));
                await this.nsStoreDispatch('setLimit', this.getUrlQueryParam('limit', 10, true));

                this.defaultSortedColumns = _.cloneDeep(this.sortedColumns);

                let filters = this.nsStoreGetter('selectedFilters');
                for( let filterName in filters) {
                    if( ! filters.hasOwnProperty(filterName) ) continue;
                    let decode = this.encodedFilter(filterName);
                    let value = this.getUrlQueryParam(filterName, undefined, decode);
                    if( value !== undefined ) { 
                        await this.nsStoreDispatch('setSelectedFilter', {[filterName] : value});
                    }
                }

                return new Promise(function (resolve) {
                    return resolve({});
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .report-table-wrapper{
        display: block;
        max-height:550px;
        overflow: auto;
    }

    .table-main{
        background: #fff;
        padding: 10px;
        z-index: 1;
        position: relative;
        width: calc(100% - 63px);
        float: left;
    }

    .right-sidebar{
        float: right;
        width: 63px;

        &.closed{
            background: #7d7d7d;
        }
    }

    .no-results{
        padding: 10px;
    }

    .report-filters {
        z-index: 2;
        position: relative;
    }

    .table-header{
        z-index: 2;
        position: relative;
    }

    .tables-list{
        z-index: 1;
        position: relative;
    }

    .table-wrapper-bottom{

        .pagination-wrapper {
            float:right;
        }

        &:after {
            content: "";
            display:block;
            clear:both;
        }
    }

    .flext-wrap{
        display:flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdgroupReport2.vue